var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8395 16.9285C20.8546 15.7391 21.1665 14.5729 21.746 13.5384C22.3256 12.5039 23.154 11.6348 24.1542 11.0118C23.5188 10.0925 22.6806 9.33587 21.706 8.80214C20.7315 8.2684 19.6476 7.97223 18.5403 7.93713C16.1783 7.68596 13.8885 9.36901 12.6848 9.36901C11.4579 9.36901 9.60475 7.96207 7.60918 8.00366C6.3184 8.04591 5.06042 8.42618 3.95783 9.10741C2.85524 9.78864 1.94564 10.7476 1.31765 11.8909C-1.40269 16.6623 0.626435 23.6748 3.23229 27.5317C4.53605 29.4203 6.05977 31.53 8.05354 31.4552C10.0046 31.3732 10.7332 30.1948 13.0883 30.1948C15.4215 30.1948 16.1051 31.4552 18.1393 31.4076C20.2328 31.3732 21.5519 29.5106 22.8099 27.6041C23.7466 26.2584 24.4675 24.7711 24.9457 23.1973C23.7294 22.6761 22.6914 21.8038 21.9613 20.689C21.2311 19.5742 20.8409 18.2664 20.8395 16.9285Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9973 5.4006C18.1387 4.01236 18.7011 2.22801 18.5649 0.426483C16.821 0.612047 15.2101 1.45644 14.0532 2.79142C13.4875 3.44359 13.0543 4.20231 12.7783 5.0242C12.5022 5.8461 12.3888 6.71505 12.4445 7.58138C13.3167 7.59048 14.1797 7.39894 14.9683 7.02119C15.7569 6.64345 16.4507 6.08934 16.9973 5.4006Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/appleLogo.b4b194de4ea7fa83ea577ad6c24b8656.svg";
export { ForwardRef as ReactComponent };